import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import socketConfigReducer from './socketConfigSlice';
import socketReducer from './socketSlice';
import userReducer from './userSlice';
import paymentReducer from './paymentSlice';
import documentReducer from './documentSlice';
import annotationInvoiceReducer from './annotationInvoice';
import darkModeReducer from './themeSlice';
import isUploadReducer from './reloadOnUploadSlice';
import documentUploadSlice from './documentUploadSlice';
import newDocumentSlice from './newDocumentSlice';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [
    'socketConfig',
    'socket',
    'payment',
    'user',
    'document',
    'annotationInvoice',
    'isUploaded',
    'documentUploadConfig',
    'latedUploadedDocument',
  ],
};

const rootReducer = combineReducers({
  socketConfig: socketConfigReducer,
  socket: socketReducer,
  payment: paymentReducer,
  user: userReducer,
  document: documentReducer,
  annotationInvoice: annotationInvoiceReducer,
  theme: darkModeReducer,
  isUploaded: isUploadReducer,
  documentUploadConfig: documentUploadSlice,
  latedUploadedDocument: newDocumentSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
